export type ActivationEvent = "button" | "wake_only" | "wake_with_command";
export type ActivationPlan =
  | { kind: "silent_ready"; spokenText: null; delayMs: 0 }
  | { kind: "delayed_first_use_welcome"; spokenText: string; delayMs: 1200 }
  | { kind: "daily_named_greeting"; spokenText: string; delayMs: 0 }
  | { kind: "brief_wake_acknowledgment"; spokenText: string; delayMs: 0 }
  | { kind: "direct_command"; spokenText: null; delayMs: 0 };

export function planActivation(input: {
  event: ActivationEvent;
  firstUse: boolean;
  firstWakeToday: boolean;
  name: string;
  hour: number;
  audience?: "owner" | "customer";
}): ActivationPlan {
  if (input.event === "wake_with_command") return { kind: "direct_command", spokenText: null, delayMs: 0 };
  if (input.firstUse) {
    return {
      kind: "delayed_first_use_welcome",
      spokenText: input.audience === "customer"
        ? `Welcome to your Aqua Homes project portal, ${input.name}. I’m Aqua. How can I help you?`
        : "Welcome to Aqua Draw. I’m Aqua. What would you like to create?",
      delayMs: 1200,
    };
  }
  if (input.event === "button") return { kind: "silent_ready", spokenText: null, delayMs: 0 };
  if (input.firstWakeToday) {
    const period = input.hour < 12 ? "morning" : input.hour < 18 ? "afternoon" : "evening";
    return {
      kind: "daily_named_greeting",
      spokenText: input.audience === "customer"
        ? `Good ${period}, ${input.name}. How can I help with your project today?`
        : `Good ${period}, ${input.name}. What would you like to create today?`,
      delayMs: 0,
    };
  }
  return { kind: "brief_wake_acknowledgment", spokenText: `I’m listening, ${input.name}.`, delayMs: 0 };
}

export function isSleepCommand(value: string): boolean {
  const normalized = value.trim().toLowerCase().replace(/[.!?]+$/g, "");
  return [
    "go to sleep",
    "shut up",
    "be quiet",
    "stop",
    "goodbye",
    "dormir",
    "vai dormir",
    "fica quieta",
    "cala a boca",
    "duérmete",
    "silencio",
  ].includes(normalized);
}
